var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17350_25471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 10V13",
    stroke: "#27387D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9346 4.65095L4.16561 17.0421C4.0573 17.2404 4.00018 17.4654 4 17.6945C3.99982 17.9236 4.05659 18.1487 4.16459 18.3472C4.27259 18.5456 4.42802 18.7105 4.61523 18.8251C4.80245 18.9397 5.01484 19 5.23105 19H18.7689C18.9852 19 19.1976 18.9397 19.3848 18.8251C19.572 18.7105 19.7274 18.5456 19.8354 18.3472C19.9434 18.1487 20.0002 17.9236 20 17.6945C19.9998 17.4654 19.9427 17.2404 19.8344 17.0421L13.0654 4.65095C12.9573 4.453 12.8019 4.28865 12.6149 4.1744C12.4279 4.06014 12.2159 4 12 4C11.7841 4 11.5721 4.06014 11.3851 4.1744C11.1981 4.28865 11.0427 4.453 10.9346 4.65095Z",
    stroke: "#27387D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z",
    fill: "#27387D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17350_25471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.65d876cf390656bd451f7013ec9ff21e.svg";
export { ForwardRef as ReactComponent };